export default function DSA_Graphs() {
  return <div>DSA_Graphs Component</div>;
}
